import { DataInputType, DynamicDataInput } from '@/types/automationFields.ts';

export const SHORT_DEBOUNCE_TIME = 400;
export const DEBOUNCE_TIME = 1000;

export const INTEGRATION_LOGO_BASE_PATH = '/integration_icons/';

export const BOX_SHADOW = 'inset -20px -20px 20px -20px rgba(117, 117, 117, 0.1)';
export const LEFT_BOX_SHADOW = 'inset 20px -20px 20px -20px rgba(117, 117, 117, 0.1)';

export const DEFAULT_DYNAMIC_DATA_INPUT: DynamicDataInput = {
  name: null,
  last_known_display_name: null,
  data_input_type: DataInputType.Dynamic,
  config: { source_step_id: null, output_id: null },
};

export const RERUN_STEP_CUTOFF = new Date('2025-11-25T23:31:40.278Z');

export const ELSE_CLAUSE_ID = 'else_clause';

export const AUTOMATION_NAME_MAX_LENGTH = 255;
export const AUTOMATION_DESCRIPTION_MAX_LENGTH = 2048;

export const DATASET_NOTE_MAX_LENGTH = 2048;

export const STEP_NAME_MAX_LENGTH = 128;
export const STEP_FIELD_MAX_LENGTH = 128;
export const STEP_FIELD_DESCRIPTION_MAX_LENGTH = 1024;
export const STEP_DESCRIPTION_MAX_LENGTH = 2048;
export const STEP_LOGIC_MAX_LENGTH = 4096;
